import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ModUtils, ValidationUtils } from '../../../static/utils';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-validation-email',
  templateUrl: './validation-email.component.html',
  styleUrls: ['./validation-email.component.scss'],
})
export class ValidationEmailComponent implements OnInit {
  email:any=''
  mobile:any=''
  paternal_last_name:any=''
  mother_last_name:any=''
  name:any=''
  gender:any=''
  form:any = [
  
    {
      type: 'email',
      key: 'email',
      value: ''
    },
   
]
 @Input() data: any;
  constructor(
  private authService:AuthService,private alertService:AlertService,private modalController: ModalController, private cdRef: ChangeDetectorRef,
  ) {
  
}
  ngOnInit() {
   
  }
  accept(){
    if(!this.form[0].value){
      this.alertService.presentToastError('Falta tu correo.')
       return
     }

    if(!ValidationUtils.validateEmail(this.form[0].value)){
         this.alertService.presentToastError('Escribe un correo válido (ejemplo: nombre@correo.com).')
         return
   }
    // Sin OTP por correo: solo se devuelve el email y se sigue el flujo
    this.modalController.dismiss(this.form[0].value);
  }

closeModal(){
    this.modalController.dismiss();
  }
}
